import React, { useState } from "react";

import styles from "./styles.module.scss";

const ProfileIcon = ({ user }) => {
  const [isError, setIsError] = useState(false);

  const getChar = () => {
    if (user?.userName !== "") return user?.userName?.charAt(0);

    return user?.emailId?.charAt(0);
  };

  return (
    <div className={`${styles.profile_icon} ${isError ? styles.bg : ""}`}>
      {!isError ? (
        <img
          src={user?.userImagePath}
          alt="user profile"
          onError={() => setIsError(true)}
        />
      ) : (
        <span>{getChar()}</span>
      )}
    </div>
  );
};

export default ProfileIcon;
